// export const API_URI= 'https://odidor-erp.herokuapp.com'
export const API_URI = 'https://hamilton.cyclic.app'
// export const API_URI = 'https://surrey.cyclic.app'
// export const API_URI = 'http://localhost:5000'
